import React from 'react';
import {Stage} from '../Stage';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';

type RejectedStageProps = {
    date: string,
    id: string,
    title: string,
    description: string,
    rejectionMessage?: string,
}

export const RejectedStage = (props: RejectedStageProps) => {
    const {date, id, title, description, rejectionMessage} = props

    return (
        <Stage
            expanded={true}
            icon={<ErrorOutlineIcon color="error"/>}
            id={id}
            subTitle={date}
            title={title}
        >
            <Typography>
                {description}
            </Typography>

            <Typography sx={{ fontStyle: 'italic', textDecoration: 'underline' }}>
                {rejectionMessage}
            </Typography>
        </Stage>
    )
}
